(function () {
	const flickerCollage = () => {
		const container = document.querySelector(".flicker-collage-box");
		if (!container) return; // Exit if no container is found
		const items = [...document.querySelectorAll(".flicker-collage_item")];
		let currentIndex = 0;
		let animationInterval;
		// Function to generate random coordinates at the edges of the container
		function getRandomPosition() {
			const containerRect = container.getBoundingClientRect();
			const positions = [
				{ top: 50, left: 50 },
				{ top: 100, left: 250 },
				{ top: 50, left: containerRect.width - 300 },
				{ top: 150, left: containerRect.width - 300 },
				{ top: containerRect.height - 300, left: 50 },
				{ top: containerRect.height - 300, left: containerRect.width - 300 },
			];
			return positions[Math.floor(Math.random() * positions.length)];
		}
		// Function to check if the new position overlaps with visible elements
		function isOverlapping(newTop, newLeft) {
			return items.some((item) => {
				if (!item.classList.contains("visible")) return false;
				const itemRect = item.getBoundingClientRect();
				const newRect = {
					top: newTop,
					left: newLeft,
					bottom: newTop + itemRect.height,
					right: newLeft + itemRect.width,
				};
				return (
					newRect.top < itemRect.bottom &&
					newRect.bottom > itemRect.top &&
					newRect.left < itemRect.right &&
					newRect.right > itemRect.left
				);
			});
		}
		// Update visibility of the items
		function updateVisibility() {
			// Hide all items
			items.forEach((item) => item.classList.remove("visible"));
			// Show two visible items instead of three
			for (let i = 0; i < 2; i++) {
				const index = (currentIndex + i) % items.length;
				items[index].classList.add("visible");
			}
			// Process disappearing item
			const disappearingIndex = (currentIndex + 3) % items.length;
			const disappearingItem = items[disappearingIndex];

			setTimeout(() => {
				let newTop, newLeft;
				// Ensure a unique position
				do {
					({ top: newTop, left: newLeft } = getRandomPosition());
				} while (isOverlapping(newTop, newLeft));
				// Update position and visibility
				disappearingItem.style.top = `${newTop}px`;
				disappearingItem.style.left = `${newLeft}px`;

				disappearingItem.classList.add("visible");
			}, 1500); // Adjusted timing for smoother appearance
			// Update index for the next cycle
			currentIndex = (currentIndex + 1) % items.length;
		}
		// Start or restart animation
		function startAnimation() {
			if (animationInterval) clearInterval(animationInterval); // Clear existing interval
			animationInterval = setInterval(updateVisibility, 1500); // Increased interval to 3000ms
		}
		// Handle Shopify section load and other events
		document.addEventListener("shopify:section:load", startAnimation);
		// Start animation when the DOM is fully loaded
		startAnimation();
	};
	document.addEventListener("DOMContentLoaded", flickerCollage);
})();
